import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { aiMessages } from '@atlaskit/editor-common/ai-messages';
import { fg } from '@atlaskit/platform-feature-flags';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { getAIExperienceButton, getImproveWritingAIButton, getPremiumAIButton } from '../../pm-plugins/floating-toolbar-button/floating-toolbar-button';
export var getSelectionToolbarConfig = function getSelectionToolbarConfig(_ref) {
  var editorPluginAIProvider = _ref.editorPluginAIProvider,
    aiGlobalOptIn = _ref.aiGlobalOptIn,
    api = _ref.api;
  return function (state, intl) {
    var _api$connectivity, _api$engagementPlatfo;
    if (editorPluginAIProvider.disableAISelectionToolbar) {
      return;
    }
    var disabled = editorExperiment('platform_editor_offline_editing_web', true) && (api === null || api === void 0 || (_api$connectivity = api.connectivity) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.sharedState) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.currentState()) === null || _api$connectivity === void 0 ? void 0 : _api$connectivity.mode) === 'offline';
    var isAiButtonPulse = api === null || api === void 0 || (_api$engagementPlatfo = api.engagementPlatform) === null || _api$engagementPlatfo === void 0 || (_api$engagementPlatfo = _api$engagementPlatfo.sharedState.currentState()) === null || _api$engagementPlatfo === void 0 ? void 0 : _api$engagementPlatfo.messageStates['cc-editor-ai_ai-toolbar-button-pulse'];
    var handleAiButtonMount = function handleAiButtonMount() {
      var _api$engagementPlatfo2;
      // Multiple calls to startMessage with the same message key will not result in multiple messages being shown.
      // That's why we can call it here without worrying about it being called multiple times.
      api === null || api === void 0 || (_api$engagementPlatfo2 = api.engagementPlatform) === null || _api$engagementPlatfo2 === void 0 || _api$engagementPlatfo2.actions.startMessage('cc-editor-ai_ai-toolbar-button-pulse');
    };
    var improveWritingBtn = getImproveWritingAIButton({
      intl: intl,
      hideTitle: false,
      aiGlobalOptIn: aiGlobalOptIn,
      disabled: disabled
    });
    if (
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    fg('ai-smart-button-team-25') || editorExperiment('platform_editor_controls', 'variant1')) {
      var askAIButton = getPremiumAIButton({
        intl: intl,
        rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
        aiGlobalOptIn: aiGlobalOptIn,
        pulse: isAiButtonPulse,
        onMount: handleAiButtonMount,
        disabled: disabled
      });
      var seperator = {
        type: 'separator',
        fullHeight: true
      };

      /**
       * We want to show AI button on left most side of floating toolbar.
       * Higher the rank, the more left it will be.
       * We are setting rank to 10 to show AI button on left most side.
       */
      return {
        rank: 10,
        isToolbarAbove: true,
        items: [improveWritingBtn, askAIButton].concat(_toConsumableArray(editorExperiment('platform_editor_controls', 'variant1') && fg('platform_editor_controls_patch_6') ? [seperator] : []))
      };
    } else {
      var aiExperienceBtn = getAIExperienceButton({
        intl: intl,
        rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
        hideTitle: true,
        aiGlobalOptIn: aiGlobalOptIn,
        title: aiMessages.tryAIToolbarIconTitle,
        tooltip: aiMessages.tryAIToolbarIconTooltip,
        pulse: isAiButtonPulse,
        onMount: handleAiButtonMount,
        disabled: disabled
      });
      return {
        rank: -10,
        isToolbarAbove: true,
        items: [improveWritingBtn, aiExperienceBtn]
      };
    }
  };
};